import { RoomDisplayResult } from 'src/app/shared/types/room-display-result';
import { Round } from 'src/app/shared/types/round';
import { GameId } from '../game/game-id';
import { z } from 'zod';

export const RoomCreationMethodSchema = z.enum(['CODE', 'MATCH']);
export type RoomCreationMethod = z.infer<typeof RoomCreationMethodSchema>;

const RoomOpponentSchema = z
  .object({
    invoice: z.string().optional(),
    nick: z.string(),
    roundDeadline: z.number().optional(),
    roundState: z.nativeEnum(Round),
    startRoundDeadline: z.number().optional(),
    score: z.number().optional(),
    userId: z.string().nullable().optional(),
  })
  .optional();

export const RoomModelSchema = z.object({
  creationMethod: RoomCreationMethodSchema,
  logicVersion: z.number().default(1),
  gameId: z.nativeEnum(GameId),
  currency: z.string().optional(),
  entryFee: z.number(),
  joinDeadline: z.number(),
  result: z.nativeEnum(RoomDisplayResult),
  resultSent: z.boolean().optional(),
  reward: z.number(),
  roundDeadline: z.number().optional(),
  roundState: z.nativeEnum(Round),
  score: z.number().optional(),
  opponent: RoomOpponentSchema,
  sortDate: z.number(),
  startRoundDeadline: z.number(),
  bounty: z
    .object({
      amount: z.number(),
      jackpot: z.boolean(),
    })
    .optional(),
});

export type RoomModel = z.infer<typeof RoomModelSchema>;
